export interface FooterLink {
  label: string;
  href: string;
}

export interface SocialLinks {
  facebook: string;
  instagram: string;
  youtube: string;
}

export interface FooterLinkSection {
  title: string;
  links: FooterLink[];
}

export interface FooterConfig {
  sections: FooterLinkSection[];
  b2b: FooterLink[];
  legal: FooterLink[];
  brandLinks: FooterLink[];
  social: SocialLinks;
}

// Social media links for BBQ
export const socialLinks = {
  bbq: {
    facebook: "https://www.facebook.com/bbqislandliquidators",
    instagram: "https://www.instagram.com/bbqislandliquidators/",
    youtube: "https://www.youtube.com/@bbqislandliquidators",
  },
};

// BBQ Footer Links
export const bbqFooterLinks = {
  shop: [
    { label: "Outdoor Kitchens", href: "/outdoor-kitchens" },
    { label: "Grills", href: "/grills" },
    { label: "Smokers", href: "/smokers" },
    { label: "Pizza Ovens", href: "/pizza-ovens" },
    { label: "Refrigeration", href: "/refrigeration" },
    { label: "Accessories", href: "/accessories" },
    { label: "Clearance", href: "/clearance" },
  ],
  explore: [
    { label: "All Brands", href: "/outdoor-kitchen-brands" },
    { label: "All Service Areas", href: "/service-areas" },
    { label: "Blaze vs Coyote", href: "/outdoor-kitchen/compare/blaze-vs-coyote" },
    { label: "Best for Outdoor Kitchens", href: "/outdoor-kitchen/best/outdoor-kitchens" },
  ],
  exploreTexas: [
    { label: "Best for Texas Weather", href: "/outdoor-kitchen/best/texas-weather" },
  ],
  exploreCalifornia: [
    { label: "Best for California", href: "/outdoor-kitchen/best/outdoor-kitchens" },
  ],
  brands: [
    { label: "Blaze Grills", href: "/outdoor-kitchen/blaze-grills" },
    { label: "Coyote Grills", href: "/outdoor-kitchen/coyote-grills" },
    { label: "Big Green Egg", href: "/outdoor-kitchen/big-green-egg" },
    { label: "Traeger", href: "/outdoor-kitchen/traeger-grills" },
    { label: "Napoleon", href: "/outdoor-kitchen/napoleon-grills" },
    { label: "Kamado Joe", href: "/outdoor-kitchen/kamado-joe" },
  ],
  services: [
    { label: "3D Design Wizard", href: "/design-wizard" },
    { label: "Design Services", href: "/design-services" },
    { label: "Financing", href: "/financing" },
    { label: "Warranty Info", href: "/warranty" },
    { label: "Delivery & Installation", href: "/delivery" },
    { label: "Showroom", href: "/showroom" },
    { label: "Track Your Order", href: "/order-tracker" },
    { label: "Get a Quote", href: "/quote" },
  ],
  locations: [
    { label: "All Service Areas", href: "/service-areas" },
    { label: "Dallas", href: "/tx/dallas/" },
    { label: "Houston", href: "/tx/houston/" },
    { label: "Austin", href: "/tx/austin/" },
    { label: "San Antonio", href: "/tx/san-antonio/" },
    { label: "Fort Worth", href: "/tx/fort-worth/" },
  ],
  californiaLocations: [
    { label: "Inland Empire", href: "/ca/inland-empire/" },
    { label: "Los Angeles", href: "/ca/los-angeles/" },
    { label: "Inland Empire Showroom", href: "/showrooms/inland-empire/" },
  ],
  b2b: [
    { label: "Commercial Outdoor Kitchens", href: "/commercial" },
    { label: "Trade & Commercial", href: "/trade" },
  ],
  resources: [
    { label: "Buying Guide", href: "/buying-guide" },
    { label: "Guides & Tips", href: "/guides" },
  ],
  legal: [
    { label: "Privacy Policy", href: "/privacy" },
    { label: "Terms of Service", href: "/terms" },
  ],
};
